import moment from 'moment'
import React from 'react'

import { ReactComponent as CheckInIcon } from 'assets/svgs/check-in.svg'
import { BOOKING_STATUS, BOOKING_STATUS_LABEL } from 'constants/Booking'

import { COLORS } from '../../constants'
import type { BerthCard } from '../../types'
import { getUnassignedCardTheme } from '../../utils/cardTheme'
import { LoadingAndUnLoadingBadge } from '../LoadingAndUnLoadingBadge'

import styles from './index.module.css'

type Props = {
  card: BerthCard
  disabled?: boolean
  onClick?: () => void
}

export const UnassignedBookingCard: React.FC<Props> = ({ card, disabled, onClick }) => {
  const theme = getUnassignedCardTheme(
    card.status,
    card.generalBookingId,
    card.generalBookingWaitingStatus
  )
  const isWhiteBg = theme.bgColor === COLORS.white
  const borderColor = isWhiteBg ? theme.color : theme.bgColor
  const isGeneralBooking = card.generalBookingId != null
  const isRecept = card.status === BOOKING_STATUS.Recept
  const badgeColor = isWhiteBg ? theme.color : COLORS.white

  const [item1, item2, item3, item4, item5, item6] = card.cardViewItems

  return (
    <div
      className={`${styles.cardItem} ${disabled ? styles.cardItemDisabled : ''}`}
      style={{
        color: theme.color,
        background: theme.bgColor,
        borderColor,
      }}
      onClick={!disabled ? onClick : undefined}
    >
      {/* ヘッダー行 */}
      <div className={styles.headerRow}>
        <div className={styles.headerLeft}>
          <span className={styles.statusLabel}>
            {BOOKING_STATUS_LABEL[card.status as keyof typeof BOOKING_STATUS_LABEL] ||
              String(card.status)}
          </span>
          <div className={styles.badgeGroup}>
            <LoadingAndUnLoadingBadge
              isUnloadActive={card.cardType === '卸' || card.cardType === '卸積'}
              isLoadActive={card.cardType === '積' || card.cardType === '卸積'}
              color={badgeColor}
              activeTextColor={theme.bgColor}
              size={20}
            />
            {isGeneralBooking && (
              <span
                className={styles.generalBadge}
                style={{
                  backgroundColor: isWhiteBg ? theme.color : COLORS.white,
                  color: isWhiteBg ? COLORS.white : theme.bgColor,
                }}
              >
                総
              </span>
            )}
          </div>
        </div>
        {isRecept &&
          card.checkinDate &&
          (!isGeneralBooking ||
            card.generalBookingWaitingStatus == null ||
            card.generalBookingWaitingStatus === 0) && (
            <span className={styles.checkinTime}>
              <CheckInIcon className={styles.checkinIcon} />
              {moment(card.checkinDate).format('HH:mm')}
            </span>
          )}
      </div>

      {/* card_view_order 3行 × 2列 */}
      <div className={styles.itemGrid}>
        <div className={styles.itemRow}>
          <span className={styles.itemCell}>{item1 || 'ー'}</span>
          <span className={styles.itemSep}>/</span>
          <span className={styles.itemCell}>{item4 || 'ー'}</span>
        </div>
        <div className={styles.itemRow}>
          <span className={styles.itemCell}>{item2 || 'ー'}</span>
          <span className={styles.itemSep}>/</span>
          <span className={styles.itemCell}>{item5 || 'ー'}</span>
        </div>
        <div className={styles.itemRow}>
          <span className={styles.itemCell}>{item3 || 'ー'}</span>
          <span className={styles.itemSep}>/</span>
          <span className={styles.itemCell}>{item6 || 'ー'}</span>
        </div>
      </div>
    </div>
  )
}
